import { YOO_FINDS_H5_CDN_URL } from "@/common/domains";

const ROOT = `${YOO_FINDS_H5_CDN_URL}/h5/activity/2026/lovers`;

export const LOVERS_BEARHEART = `${ROOT}/bearheart.png`;
export const LOVERS_LETTER = `${ROOT}/letter.png`;
export const LOVERS_ARROWHEART = `${ROOT}/arrowheart.png`;
